import {
  CNPIcon,
  EHPRDIcon,
  GHGActivitiesIcon,
  ReportDeclarationIcon,
  ExternalSupportIcon,
} from "../../../assets/icons/sidebar";

export const LOGIN = {
  SIDEBAR_DES:
    "Your trusted guide for navigating every step of the journey toward achieving net-zero emissions—through clear planning, targeted reduction strategies, and transparent reporting.",
  LOGIN_WELCOME: "Welcome Back",
  LOGIN_TEXT: "Sign in to continue your carbon neutral journey",
};

export const LOGIN_SIDEBAR_ITEMS = [
  {
    title: "GHG Emission Activities",
    label: "Track and manage your organization’s greenhouse gas emissions.",
    icon: GHGActivitiesIcon,
  },
  {
    title: "Hotspots",
    label: "Identify major emission sources for targeted action.",
    icon: EHPRDIcon,
  },
  {
    title: "Carbon Neutral Planning",
    label: "Set strategies to reach net-zero emissions effectively.",
    icon: CNPIcon,
  },
  {
    title: "External Support",
    label: "Access expert help for sustainability efforts.",
    icon: ExternalSupportIcon,
  },
  {
    title: "Report Declaration",
    label: "Submit and share your emissions and reduction progress.",
    icon: ReportDeclarationIcon,
  },
];
